import React from 'react';
import { useGameStore } from '../store/gameStore';

const SettingsModal = () => {
  const {
    settingsOpen,
    closeSettings,
    tileSize,
    setTileSize,
    showTilePinyin,
    setShowTilePinyin,
    showTileEnglish,
    setShowTileEnglish,
  } = useGameStore();
  
  if (!settingsOpen) return null;
  
  const handleSizeChange = (e) => {
    setTileSize(parseInt(e.target.value));
  };

  const handleTogglePinyin = () => {
    setShowTilePinyin(!showTilePinyin);
  };

  const handleToggleEnglish = () => {
    setShowTileEnglish(!showTileEnglish);
  };
  
  const modalOverlayStyle = {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,0.6)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 100,
  };
  
  const modalStyle = {
    background: '#1e293b',
    border: '1px solid #334155',
    borderRadius: '16px',
    padding: '24px',
    width: '90%',
    maxWidth: '400px',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  };
  
  const labelStyle = {
    fontSize: '0.85rem',
    color: '#94a3b8',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  };
  
  const rangeStyle = {
    width: '100%',
    height: '6px',
    borderRadius: '3px',
    background: '#334155',
    outline: 'none',
    appearance: 'none',
    WebkitAppearance: 'none',
  };
  
  const previewStyle = {
    background: '#312e81',
    border: '2px solid #6366f1',
    borderRadius: '8px',
    width: `${tileSize}px`,
    height: `${tileSize}px`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#e2e8f0',
    fontSize: `${tileSize * 0.52}px`,
    transition: 'width 0.1s, height 0.1s, font-size 0.1s',
  };
  
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      closeSettings();
    }
  };
  
  return (
    <div 
      className="modal-overlay open" 
      style={modalOverlayStyle}
      onClick={handleOverlayClick}
    >
      <div className="modal" style={modalStyle}>
        <h2 style={{ fontSize: '1.1rem', color: '#f1f5f9', margin: 0 }}>
          ⚙ Settings
        </h2>
        
        <label style={labelStyle}>
          Tile size
          <input
            type="range"
            min="36"
            max="140"
            value={tileSize}
            onChange={handleSizeChange}
            step="2"
            style={rangeStyle}
          />
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.7rem', color: '#64748b' }}>
            <span>36px (tiny)</span>
            <span>140px (huge)</span>
          </div>
        </label>
        
        <label style={{ display: 'flex', alignItems: 'center', gap: '12px', fontSize: '0.85rem', color: '#94a3b8', cursor: 'pointer' }}>
          <input
            type="checkbox"
            checked={showTilePinyin}
            onChange={handleTogglePinyin}
            style={{ width: '18px', height: '18px', accentColor: '#6366f1', cursor: 'pointer' }}
          />
          Show pinyin on tiles
        </label>

        <label style={{ display: 'flex', alignItems: 'center', gap: '12px', fontSize: '0.85rem', color: '#94a3b8', cursor: 'pointer' }}>
          <input
            type="checkbox"
            checked={showTileEnglish}
            onChange={handleToggleEnglish}
            style={{ width: '18px', height: '18px', accentColor: '#6366f1', cursor: 'pointer' }}
          />
          Show English on tiles
        </label>

        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}>
          <span style={{ fontSize: '0.8rem', color: '#94a3b8' }}>Preview:</span>
          <div style={previewStyle}>
            {(showTilePinyin || showTileEnglish) ? (
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2px' }}>
                <span style={{ fontSize: `${tileSize * (showTilePinyin && showTileEnglish ? 0.42 : 0.48)}px`, lineHeight: 1 }}>好</span>
                {showTilePinyin && (
                  <span style={{ fontSize: `${tileSize * 0.18}px`, color: '#cbd5e1' }}>hǎo</span>
                )}
                {showTileEnglish && (
                  <span style={{ fontSize: `${tileSize * 0.14}px`, color: '#94a3b8' }}>good</span>
                )}
              </div>
            ) : '好'}
          </div>
        </div>
        
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
          <button
            onClick={closeSettings}
            style={{
              background: '#334155',
              color: '#e2e8f0',
              padding: '8px 20px',
              borderRadius: '8px',
              border: 'none',
              fontSize: '0.85rem',
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default SettingsModal;
